import LocationLayout from './LocationLayout';
import { P, H2b, UL, LI } from '../content/Typography';
import { locations } from './locations';

const meta = locations.find((l) => l.slug === 'metal-fabrication-ottawa');

export default function Ottawa() {
  return (
    <LocationLayout title={meta.title} description={meta.description} heading={meta.heading}>
      <H2b>A fabrication sector shaped by defence and government</H2b>
      <P>
        Ottawa's fabrication landscape looks different from the rest of Ontario because of who is buying. As the seat of the federal government and home to
        a significant defence and aerospace contracting base, the city has a tier of fabricators built around the requirements those clients bring —
        controlled goods compliance, documented quality processes, and in some cases, staff holding security clearances. Even for clients outside the
        defence sector, this means Ottawa shops tend to be disciplined about documentation and process, which carries over into how they handle any project.
      </P>

      <H2b>Security clearances and controlled work</H2b>
      <P>
        Some Ottawa fabricators are set up specifically to handle government and defence contracts requiring personnel with security clearances or
        compliance with Canada's Controlled Goods Program. If your project has similar requirements, Ottawa is one of the few Ontario markets where that
        capability is readily available rather than a rare exception.
      </P>

      <H2b>Tech sector enclosure demand</H2b>
      <P>
        Ottawa's other defining industry is technology — the city's telecom and photonics roots, still visible in the Kanata tech corridor, have created
        steady demand for precision sheet metal enclosures, chassis, and mounting hardware for hardware and networking products. Fabricators serving this
        segment are used to smaller production runs and faster iteration than the defence side of the market typically requires.
      </P>

      <H2b>Coverage across the National Capital Region</H2b>
      <P>
        MetalMatch's Ottawa network extends across the wider National Capital Region, not just the downtown core. That includes Kanata's tech corridor,
        Orleans to the east, and — for clients comfortable sourcing across the provincial border — fabricators in Gatineau on the Quebec side of the river.
      </P>
      <UL>
        <LI><strong>Government and defence contractors</strong> — controlled goods compliance, documented quality processes, cleared personnel where required.</LI>
        <LI><strong>Tech and telecom companies</strong> — precision enclosures and chassis for hardware and networking products.</LI>
        <LI><strong>Local businesses and institutions</strong> — general fabrication, fixtures, and custom metalwork across the region.</LI>
      </UL>
      <P>
        These two client bases have very different expectations — a defence contractor typically needs documentation and process rigor above almost
        anything else, while a Kanata hardware startup usually cares more about turnaround time on a small run. Matching your project to a shop that
        actually prioritizes what you need saves real time compared to a generic quote request.
      </P>
      <P>
        Submit a sketch of your project and MetalMatch will match you with an Ottawa-area fabricator suited to your requirements — whether that means a
        shop equipped for controlled government work or one focused on fast-turnaround tech enclosures.
      </P>
    </LocationLayout>
  );
}
